export interface Testimonial {
  id: number
  content: string
  author: string
  role: string
  location: string
}

export interface TestimonialsTranslations {
  title: string
  subtitle: string
  socialProofTitle: string
  metrics: {
    averageRating: string
    happyClients: string
    yearsExperience: string
  }
  socialProof: string
  googleReviews: {
    title: string
    subtitle: string
    rating: string
    reviews: string
    cta: string
    leaveReview: string
  }
  testimonials: Testimonial[]
}

export const testimonialsTranslations: Record<'en' | 'cy', TestimonialsTranslations> = {
  en: {
    title: 'What My Clients Say',
    subtitle: 'Don\'t just take my word for it - hear from my satisfied customers',
    socialProofTitle: 'Trusted by Garden Lovers',
    metrics: {
      averageRating: 'Average Rating',
      happyClients: 'Happy Clients',
      yearsExperience: 'Years Experience'
    },
    socialProof: "Join 100+ satisfied clients across South Wales",
    googleReviews: {
      title: 'Google Reviews',
      subtitle: 'What our customers say about us',
      rating: '5.0 out of 5',
      reviews: '2 reviews',
      cta: 'Read Reviews',
      leaveReview: 'Leave a Review'
    },
    testimonials: [
      {
        id: 1,
        content: "JC Gardening transformed my neglected garden into a beautiful outdoor space. His attention to detail and professional service exceeded my expectations. He was punctual, courteous, and left the site spotless.",
        author: "Sarah M.",
        role: "Homeowner",
        location: "Penarth"
      },
      {
        id: 2,
        content: "I've been using JC Gardening for my monthly maintenance for over a year now. His consistent quality and reliability have made him an invaluable part of my home maintenance routine. Highly recommended!",
        author: "David L.",
        role: "Property Manager",
        location: "Barry"
      },
      {
        id: 3,
        content: "Professional, reliable, and excellent attention to detail. My garden has never looked better since I started working with JC Gardening. He always arrives on time and completes the work to the highest standard.",
        author: "Emma R.",
        role: "Business Owner",
        location: "Bridgend"
      }
    ]
  },
  cy: {
    title: 'Beth Mae Fy Nghleientiaid yn ei Ddweud',
    subtitle: 'Peidiwch â chymryd fy ngair amdano - clywch gan fy nghleientiaid boddhaus',
    socialProofTitle: 'Wedi\'i Ymddiried gan Garwyr Gardd',
    metrics: {
      averageRating: 'Sgôr Gyfartalog',
      happyClients: 'Cleientiaid Hapus',
      yearsExperience: 'Mlynedd o Brofiad'
    },
    socialProof: "Ymunwch â 100+ o gleientiaid bodlon ar draws De Cymru",
    googleReviews: {
      title: 'Adolygiadau Google',
      subtitle: 'Beth mae ein cwsmeriaid yn ei ddweud amdanom',
      rating: '5.0 allan o 5',
      reviews: '2 adolygiad',
      cta: 'Darllen Adolygiadau',
      leaveReview: 'Gadael Adolygiad'
    },
    testimonials: [
      {
        id: 1,
        content: "Trawsnewidiodd JC Gardening fy ngardd wedi'i hesgeuluso yn lle awyr agored hardd. Roedd ei sylw i fanylion a gwasanaeth proffesiynol yn rhagori ar fy nisgwyliadau. Roedd yn brydlon, yn wrtais, ac wedi gadael y safle yn berffaith.",
        author: "Sarah M.",
        role: "Perchennog Cartref",
        location: "Penarth"
      },
      {
        id: 2,
        content: "Rwyf wedi bod yn defnyddio JC Gardening ar gyfer fy nghynnal a chadw misol am dros flwyddyn bellach. Mae ei ansawdd cyson a'i ddibynadwyedd wedi ei wneud yn rhan amhrisiadwy o fy arfer cynnal a chadw cartref. Argymhellir yn uchel!",
        author: "David L.",
        role: "Rheolwr Eiddo",
        location: "Y Barri"
      },
      {
        id: 3,
        content: "Proffesiynol, dibynadwy, ac sylw rhagorol i fanylion. Nid yw fy ngardd erioed wedi edrych yn well ers i mi ddechrau gweithio gyda JC Gardening. Mae bob amser yn cyrraedd mewn pryd ac yn cwblhau'r gwaith i'r safon uchaf.",
        author: "Emma R.",
        role: "Perchennog Busnes",
        location: "Pen-y-bont ar Ogwr"
      }
    ]
  }
} 